import { PatientStatusEventType, StatusEventForm } from '@/api/dtos';

export const patientStatusCaptions = [
    'On Study',
    'WC- Partial',
    'WC- Full',
    'Lost To Follow Up',
    'Deceased',
] as const;

export type PatientStatusCaption = typeof patientStatusCaptions[number];

const priorityStatusEvents: PatientStatusEventType[] = [
    PatientStatusEventType.Deceased,
    PatientStatusEventType.LostToFollowUp,
    PatientStatusEventType.WcFull,
];

const partialWithdrawalStatusEvents = new Set<PatientStatusEventType>([
    PatientStatusEventType.WcBlood,
    PatientStatusEventType.WcQuestionnaires,
    PatientStatusEventType.WcServAus,
    PatientStatusEventType.WcDataLink,
    PatientStatusEventType.WcTissue,
    PatientStatusEventType.WcBloodSampleStorage,
    PatientStatusEventType.WcDataSharing,
    PatientStatusEventType.WcWeShareData,
]);

export interface IPatientStatusSummary {
    overallStatus: PatientStatusEventType;
    caption: PatientStatusCaption;
    partialWithdrawalStatuses: PatientStatusEventType[];
    isPartialWithdrawal: boolean;
}

export const getPatientStatusSummary = (
    statusEventForms: StatusEventForm[] | null | undefined
): IPatientStatusSummary => {
    const statusEvents = (statusEventForms ?? [])
        .map(({ statusEvent }) => statusEvent)
        .filter((statusEvent): statusEvent is PatientStatusEventType => statusEvent != null);

    const partialWithdrawalStatuses = statusEvents.filter(statusEvent =>
        partialWithdrawalStatusEvents.has(statusEvent)
    );

    const overallStatus = priorityStatusEvents.find(statusEvent =>
        statusEvents.includes(statusEvent)
    ) ?? partialWithdrawalStatuses[partialWithdrawalStatuses.length - 1] ?? PatientStatusEventType.OnStudy;

    switch (overallStatus) {
        case PatientStatusEventType.Deceased:
            return { overallStatus, caption: 'Deceased', partialWithdrawalStatuses, isPartialWithdrawal: false };
        case PatientStatusEventType.LostToFollowUp:
            return { overallStatus, caption: 'Lost To Follow Up', partialWithdrawalStatuses, isPartialWithdrawal: false };
        case PatientStatusEventType.WcFull:
            return { overallStatus, caption: 'WC- Full', partialWithdrawalStatuses, isPartialWithdrawal: false };
        case PatientStatusEventType.OnStudy:
            return { overallStatus, caption: 'On Study', partialWithdrawalStatuses, isPartialWithdrawal: false };
        default:
            return { overallStatus, caption: 'WC- Partial', partialWithdrawalStatuses, isPartialWithdrawal: true };
    }
};
